/**
 * Authentication Utility
 * Handles token storage and validation
 */

import { ELocalStorageKey } from './constants';

const USER_KEY = 'pilotUser';

/**
 * Store authentication data
 * @param {string} token - Authentication token
 * @param {Object} user - User information
 */
export const setAuth = (token, user) => {
  if (!token) return false;
  
  try {
    // Store token
    console.log('Storing auth token:', token.substring(0, 10) + '...');
    localStorage.setItem(ELocalStorageKey.Token, token);
    
    // Store user data
    if (user) {
      console.log('Storing user data:', user);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    }
    
    return true;
  } catch (error) {
    console.error('Error storing auth data:', error);
    return false;
  }
};

/**
 * Get the current authentication token
 * @returns {string|null} The auth token or null if not authenticated
 */
export const getToken = () => {
  try {
    return localStorage.getItem(ELocalStorageKey.Token);
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

/**
 * Get the current authenticated user
 * @returns {Object|null} The user object or null if not authenticated
 */
export const getUser = () => {
  try {
    const userJson = localStorage.getItem(USER_KEY);
    return userJson ? JSON.parse(userJson) : null;
  } catch (error) {
    console.error('Error getting user data:', error);
    return null;
  }
};

/**
 * Check if the user is authenticated
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const token = getToken();
  console.log('Auth check - token exists:', !!token);
  return !!token;
};

/**
 * Remove authentication data (logout)
 */
export const clearAuth = () => {
  try {
    localStorage.removeItem(ELocalStorageKey.Token);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(ELocalStorageKey.Username);
    localStorage.removeItem(ELocalStorageKey.UserId);
    localStorage.removeItem(ELocalStorageKey.MqttConfig);
    return true;
  } catch (error) {
    console.error('Error clearing auth data:', error);
    return false;
  }
};

/**
 * Set authorization headers for API requests
 * @param {Object} headers - Headers object to add auth to
 * @returns {Object} Headers with auth token
 */
export const authHeaders = (headers = {}) => {
  const token = getToken();
  if (!token) return headers;
  
  return {
    ...headers,
    'x-auth-token': token
  };
}; 